import styled from 'styled-components';
import React, { useState, useEffect, useRef } from "react";
import Slide from "../slideMain.js";
import Slide_img from "../img/Main_slide.png";
import Home_item_1 from "./home_item1.js";
function Home(){
    return (
        <Wrapper>
            <Slide imgURL={Slide_img} inputText=""/>
            <Home_item_1/>
        </Wrapper>

    )
}  

const Wrapper = styled.div`
position : relative; 
top : 90px;

`
export default Home;